/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tickets_Api_Errors_Only_Latest_Message_DeletableInputs */

const nl_tickets_api_errors_only_latest_message_deletable = /** @type {(inputs: Tickets_Api_Errors_Only_Latest_Message_DeletableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alleen het laatste bericht in het gesprek kan worden verwijderd.`)
};

/**

* @param {Tickets_Api_Errors_Only_Latest_Message_DeletableInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const tickets_api_errors_only_latest_message_deletable = /** @type {((inputs?: Tickets_Api_Errors_Only_Latest_Message_DeletableInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tickets_Api_Errors_Only_Latest_Message_DeletableInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_tickets_api_errors_only_latest_message_deletable(inputs)
});
export { tickets_api_errors_only_latest_message_deletable as "tickets.api_errors.only_latest_message_deletable" }